function createThrottledQueue(cb, interval) {
    let items = [];
    let timer = null;
    const flush = () => {
        cb([...items]);
        timer = null;
        items = [];
    };
    return {
        add(item) {
            items.push(item);
            if (timer === null) {
                timer = window.setTimeout(flush, interval);
            }
        },
        flush,
    };
}
export default createThrottledQueue;
